'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListJacketCover = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _GenericPlaceholder = require('./GenericPlaceholder.component');

var _GenericPlaceholder2 = _interopRequireDefault(_GenericPlaceholder);

var _ReadalikePlaceholder = require('./ReadalikePlaceholder.component');

var _ReadalikePlaceholder2 = _interopRequireDefault(_ReadalikePlaceholder);

require('../styles/ListJacketCover.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListJacketCover = exports.ListJacketCover = function (_BcReactComponent) {
  _inherits(ListJacketCover, _BcReactComponent);

  function ListJacketCover(props) {
    _classCallCheck(this, ListJacketCover);

    var _this = _possibleConstructorReturn(this, (ListJacketCover.__proto__ || Object.getPrototypeOf(ListJacketCover)).call(this, props));

    _this.state = { imageIsValid: false };
    return _this;
  }

  _createClass(ListJacketCover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.validateImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.imageIsValid) {
        return;
      }

      if (this.props.src !== nextProps.src) {
        this.setState({ imageIsValid: false });
        this.validateImage(nextProps);
      }
    }
  }, {
    key: 'validateImage',
    value: function validateImage(newProps) {
      var _this2 = this;

      var src = newProps.src;
      if (src) {
        var testImage = new Image();
        testImage.onload = function () {
          _this2.setState({
            imageIsValid: testImage.width > 1 && testImage.height > 1
          });
        };
        testImage.src = src;
      }
    }
  }, {
    key: 'renderPlaceholder',
    value: function renderPlaceholder() {
      var _props = this.props,
          listType = _props.listType,
          anchorBibJacketCover = _props.anchorBibJacketCover;


      var jacketCoverURL = null;
      if (anchorBibJacketCover) {
        jacketCoverURL = anchorBibJacketCover.get('localUrl') || anchorBibJacketCover.get('largeCover');
      }

      if (listType === 'read_a_like') {
        return _react2.default.createElement(_ReadalikePlaceholder2.default, { anchorBibSrc: jacketCoverURL });
      }

      return _react2.default.createElement(_GenericPlaceholder2.default, { anchorBibSrc: jacketCoverURL });
    }
  }, {
    key: 'renderCover',
    value: function renderCover() {
      var imageIsValid = this.state.imageIsValid;


      if (imageIsValid) {
        return _react2.default.createElement('img', { alt: '', src: this.props.src });
      }

      return this.renderPlaceholder();
    }
  }, {
    key: 'renderDraftMessage',
    value: function renderDraftMessage() {
      if (this.props.isDraft) {
        return _react2.default.createElement(
          'div',
          { className: 'draft-message', 'data-test-id': 'list-jacket-draft-message' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_draft_jacket_cover' })
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-jacket-cover' },
        this.renderCover(),
        this.renderDraftMessage()
      );
    }
  }]);

  return ListJacketCover;
}(_baseBcReactComponent2.default);

ListJacketCover.propTypes = {
  isDraft: _react.PropTypes.bool,
  listType: _react.PropTypes.string,
  src: _react.PropTypes.string,
  anchorBibJacketCover: _react.PropTypes.shape({
    localUrl: _react.PropTypes.string,
    largeCover: _react.PropTypes.string
  }),
  intl: _reactIntl.intlShape
};

exports.default = (0, _reactIntl.injectIntl)(ListJacketCover);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-jacket-cover/components/ListJacketCover.component.js
// module id = 1311
// module chunks = 0